<template>
  <div class="editPassword">
    <h2> 修改密码 </h2>
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input type="password" v-model="form.oldPassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="form.newPassword" placeholder="密码长度应在8-16位之间"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input type="password" v-model="form.confirmPassword" placeholder="密码长度应在8-16位之间"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="button-container">
          <el-button type="primary" @click="submitForm('form')">确认</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { changePassword } from '@/api/login'
import { AesEncode } from '../../utils/encryptAes'

export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('密码长度应在8-16位之间'));
      } else if (value  === this.form.oldPassword) {
        callback(new Error('新密码不能和旧密码相同'));
      } else {
        callback();
      }
    };
    let validateConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, validator: validateConfirm, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('确认修改密码吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const params = {
              old_password: AesEncode(this.form.oldPassword),
              new_password: AesEncode(this.form.newPassword),
            }
            changePassword(params).then(res =>{
              if(res && res.code === 2000) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                this.$store.dispatch('user/loginOut'); // 强制退出登录
              }
            }).catch(() => {
              this.$message({
                type: 'error',
                message: '修改失败!'
              });
            })
          }).catch(() => {

          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
  .editPassword{
    width: 450px !important;
    margin: 50px auto;
    padding: 50px 0;
    border-radius: 30px;
    border: 1px solid #cccccc;
    background: #fff !important;
  }

  .editPassword h2 {
    text-align: center;
    margin-bottom: 30px;
  }

 .editPassword .el-form-item__content {
   width: 300px;
 }

 .editPassword .button-container {
   text-align: center;
   margin-top: 20px;
   margin-left: -80px
 }
</style>